import { __awaiter, __rest } from "tslib";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import axios from 'axios';
import React from 'react';
import { useAsyncFetch } from 'react-hooks-async-handlers';
import Lottie from 'react-lottie';
function LottieRemote(props) {
    const { url, options, onLoad } = props, extraProps = __rest(props, ["url", "options", "onLoad"]);
    const lottieFetchAction = useAsyncFetch(() => __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(url);
        onLoad === null || onLoad === void 0 ? void 0 : onLoad();
        return data;
    }));
    if (!lottieFetchAction.isDone && !lottieFetchAction.data)
        return null;
    return (_jsx(Lottie, Object.assign({ options: Object.assign(Object.assign({}, options), { animationData: lottieFetchAction.data }) }, extraProps, { isClickToPauseDisabled: true, style: {
            cursor: 'initial',
        } })));
}
export default LottieRemote;
